// extracted by mini-css-extract-plugin
export default {"flowBadge":"WorkFlowStatus_flowBadge__a4Mbo"};